import UserShopViewModel from "./UserbuyShopViewModel";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useState } from "react";
const ViewModel = () => {
    const [modalShow, setModalShow] = useState(true)
  return (
    <>


      <UserShopViewModel show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default ViewModel;
